import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, map, of, switchMap } from 'rxjs'
import * as GeolocationActions from './geolocation.actions'
import { GeolocationApiService } from './geolocation-api.service'
import { Geolocation } from './geolocation.models'

@Injectable()
export class GeolocationEffects {
  private actions$ = inject(Actions)

  getGeoLocation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GeolocationActions.loadGeoLocation),
      switchMap(() => {
        return this.geoLocationApiService.getGeolocation().pipe(
          map((geolocation: Geolocation) => GeolocationActions.loadGeolocationSuccess({ geolocation })),
          catchError((error) => {
            console.error(error)
            return of(GeolocationActions.loadGeolocationFailure({ error }))
          }),
        )
      }),
    ),
  )

  constructor(private geoLocationApiService: GeolocationApiService) {}
}
